import React from 'react'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { notifierActions } from '../../../redux/slices/notifier/notifier'
import { useTypedDispatch, useTypedSelector } from '../../../redux/store'

let displayed = []

const Notifier = () => {
    const dispatch = useTypedDispatch()
    const notifications = useTypedSelector((store) => store.notifier.notifications || [])
    const { enqueueSnackbar } = useSnackbar()
    const { t } = useTranslation()

    const storeDisplayed = (id) => {
        displayed = [...displayed, id]
    }

    const removeDisplayed = (id) => {
        displayed = [...displayed.filter((key) => id !== key)]
    }

    React.useEffect(() => {
        notifications.forEach(({ key, message, options = { onClose: null } }) => {
            // do nothing if snackbar is already displayed
            if (displayed.includes(key)) return

            // display snackbar using notistack
            enqueueSnackbar(t(message), {
                key,
                ...options,
                onClose: (event, reason, myKey) => {
                    if (options.onClose) {
                        options.onClose(event, reason, myKey)
                    }
                },
                onExited: (event, myKey) => {
                    // remove this snackbar from redux store
                    dispatch(notifierActions.removeSnackbar(myKey))
                    removeDisplayed(myKey)
                },
            })

            // keep track of snackbars that we've displayed
            storeDisplayed(key)
        })
    }, [notifications, enqueueSnackbar, dispatch])

    return null
}

export default Notifier
